import React, { useContext, useEffect, useState } from "react";
import FlowContext from "../../../../contexts/flowContext";
import { Tooltip } from "antd";
import formStyles from "./duplicate.module.css";
import styles from "../controls.module.css";
import BackCurtain from "../../../BackCurtain";
import { IoDuplicateOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";

const Duplicate = () => {
  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [visibleForm, setVisibleForm] = React.useState(false);

  const [app, setApp] = useState("");
  const [brand, setBrand] = React.useState("");
  const [flowName, setFlowName] = useState("");
  const [flowVersion, setFlowVersion] = useState("");

  useEffect(() => {
    const url = new URL(window.location.href);

    const paths = url.pathname.split("/").filter(Boolean);

    setApp(paths[0]);
    setBrand(paths[1]);
    setFlowName(paths[2]);
    setFlowVersion(`${paths[3]}-copy`);
  }, [visibleForm]);

  const handleDuplicateButtonClick = function () {
    if (visibleForm) {
      return;
    }
    setVisibleForm(true);
  };

  const handleValidateButtonClick = function () {
    //window.open(window.location.href, "_blank");
    const url = new URL(window.location.href);
    const baseUrl = url.protocol + "//" + url.host;
    const app = url.pathname.split("/").filter(Boolean)[0];

    window.open(
      baseUrl + `/${app}/${brand}/${flowName}/${flowVersion}`,
      "_blank"
    );

    const { nodes, edges, globalParameters } = flowState;

    localStorage.setItem(
      "duplicated-flow",
      JSON.stringify({
        app,
        brand,
        nodes,
        edges,
        globalParameters,
        name: flowName,
        version: flowVersion,
        isSynchronizedWithPublishedConfig: false,
      })
    );

    setVisibleForm(false);
  };

  return (
    <div
      className={styles.button_container}
      onClick={handleDuplicateButtonClick}
    >
      {visibleForm && <BackCurtain />}

      <Tooltip placement="bottom" title={"Duplicate"}>
        <span className={styles.icon_container}>
          <IoDuplicateOutline className={styles.duplicate_button} />
        </span>
      </Tooltip>
      {visibleForm && (
        <div className={formStyles.form_container}>
          <div className={formStyles.close_button_container}>
            <span
              className={formStyles.close_button}
              onClick={() => setVisibleForm(false)}
            >
              <IoMdClose />
            </span>
          </div>
          <div className={formStyles.form_control}>
            <div className={formStyles.form_label}>
              <label>Brand</label>
            </div>
            <input
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
          <div className={formStyles.form_control}>
            <div className={formStyles.form_label}>
              <label>Name</label>
            </div>
            <input
              type="text"
              value={flowName}
              onChange={(e) => setFlowName(e.target.value)}
            />
          </div>
          <div className={formStyles.form_control}>
            <div className={formStyles.form_label}>
              <label>Version</label>
            </div>
            <input
              type="text"
              value={flowVersion}
              onChange={(e) => setFlowVersion(e.target.value)}
            />
          </div>
          <div className={formStyles.validate_button_container}>
            <button
              className={formStyles.validate_button}
              onClick={handleValidateButtonClick}
            >
              Duplicate
            </button>
          </div>
          <div className={formStyles.warning_zone}>
            <span>
              Attention, la duplication comprend la copie intégrale du flow et
              des configs. Cela peut inclure des données à stocker dans la db.
              Pensez à les changer si nécessaire.
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Duplicate;
